import { CandidateResumeFilters } from "../Interface";
import apiClient from "./api.client.service";

class UserProfileService {
  async getAllCandidateProfilesByCandidateId(
    candidateId: string,
    page: number,
    limit: number,
    filters: CandidateResumeFilters,
  ) {
    const { sort } = filters;
    let params = `?page=${page}&limit=${limit}`;
    if (sort) {
      params += `&sort=${sort}`;
    }
    try {
      const response = await apiClient.get(
        `/admin/profile-matcher/candidate/${candidateId}/resumes${params}`,
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "~ UserProfileService ~ getAllCandidateProfilesByCandidateId ~ error:",
        error,
      );
      return null;
    }
  }
}

const userProfileService = new UserProfileService();

export default userProfileService;
